var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row q-pa-none q-ma-none"},[_c('div',{staticStyle:{"margin-left":"50%","transform":"translateX(-50%)"}},[_c('h6',{staticStyle:{"margin":"3px 0px"}},[_vm._v("Loading ... ")]),_c('q-spinner-bars',{staticClass:"iconColor",staticStyle:{"margin-left":"50%","transform":"translateX(-50%)"},attrs:{"size":"sm"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }